/**
 * Simple Features exception
 */
export class UnsupportedOperationException extends Error {
	/**
	 * Constructor
	 */
	public constructor (...args) {
		super(...args)
	}
}
